import React, { Component } from "react";
import { BrowserRouter, Link, Switch, Route } from "react-router-dom";
import { Icon, Row, Col, Input, Avatar, Button, Form, message, Typography, Select } from "antd";
import axios from "axios";
import WebFont from "webfontloader";
import "./sign-in.scss";
import Logo from "../../media/CosmoRoundLogo.png";
import backGround from "./supermarket.png";
import isDev from "../../server";
import { fetchAdminUserTypeApi, fetchCountryListApi } from "utils/apiService";
const { Text } = Typography;
const { Option } = Select;
const serverUrl = isDev();

class SignInForm extends Component {
	state = {
		loading: false,
		countryList: [],
		isSuperAdmin: false,
	};

	handleSubmit = (e) => {
		e.preventDefault();
		this.props.form.validateFields((err, values) => {
			if (!err) {
				const country = JSON.parse(values.country);
				axios
					.post(`${serverUrl}/${country?.database_identifier}/reward-admin-login/`, {
						username: values.username,
						password: values.password,
					})
					.then((response) => {
						if (response.data.status === 200 || response.status === 200) {
							message.info("Login Success");
							localStorage.setItem("isLoggedIn", true);
							localStorage.setItem("token", response.data.token);
							localStorage.setItem("username", values.username);
							localStorage.setItem("countryData", values.country);

							localStorage.setItem("user_type", response.data.role);
							response.data.role === "super_admin" ? this.setState({ isSuperAdmin: true }) : window.location.reload();
						} else if (response.data.status === 403) {
							message.info("You are not authorised!");
						} else {
							message.error("Something went wrong!");
						}
					})
					.catch((error) => {
						message.error("Something went wrong!");
					});
			}
		});
	};

	componentDidMount() {
		this.props.history.replace("/");
		axios
			.post(`${serverUrl}/fetch-country-list-admin/`, {})
			.then((response) => {
				if (response.data.status === 200 || response.status === 200) {
					this.setState({
						countryList: response.data.country_list,
					});
				} else if (response.data.status === 403) {
					message.info("You are not authorised!");
				} else {
					message.error("Something went wrong!");
				}
			})
			.catch((error) => {
				message.error("Something went wrong!");
			});
	}

	render() {
		const { getFieldDecorator } = this.props.form;
		return (
			<div
				style={{
					minHeight: "100vh",

					backgroundImage: `url(${backGround})`,
				}}>
				<div
					style={{
						// opacity: "0.5",
						background: "rgb(80, 80, 80, 0.5)",
					}}>
					<Row
						type="flex"
						align="middle"
						justify="center"
						style={{
							minHeight: "100vh",
						}}>
						<Col
							span={8}
							style={{
								background: "white",
								width: "504px",
								opacity: "1 !important",
								// height: "480px",
								// marginTop: "210px",
							}}>
							{!this.state.isSuperAdmin ? (
								<>
									<div
										style={{
											textAlign: "center",
											//   display: "flex",
											//   justifyContent: "center",
											//   flexDirection: "column",
										}}>
										<div>
											<img
												src={Logo}
												style={{
													width: "87.14px",
													height: "87.14px",
													marginTop: "32px",
													//   margin: "32px",
													marginBottom: "20px",
												}}></img>
										</div>
										<div>
											{/* <Logo /> */}
											<Text
												style={{
													left: "calc(50% - 87.14px/2 - 0px)",
													fontStyle: "normal",
													fontWeight: "700",
													fontSize: "24px",
													lineHeight: "40px",
													color: "#181818",
													//   marginTop: "1px",
												}}>
												Welcome back!
											</Text>
										</div>
										<div
											style={{
												color: "#98a6ad",
												textAlign: "center",
												// marginTop: "8px",
											}}>
											We are so exited to see you again
										</div>
									</div>
									<Row type="flex" align="middle" justify="center" className="signin-form-container">
										<Col span={24}>
											<Form onSubmit={this.handleSubmit} className="login-form">
												<Row>
													<div>
														{/* <Logo /> */}
														<Text
															style={{
																//   position: "absolute",
																left: "calc(50% - 87.14px/2 - 0px)",
																//   top: "calc(50% - 31.33px/2 - 0.33px)",
																// fontFamily: "Gotham",
																fontStyle: "normal",
																fontWeight: "bold",
																fontSize: "14px",
																lineHeight: "22px",
																color: "#181818",
																marginTop: "32px",
															}}>
															Country
														</Text>
													</div>
													<Form.Item>
														{getFieldDecorator("country", {
															rules: [
																{
																	required: true,
																	message: "Please select a country!",
																},
															],
														})(
															<Select
																placeholder="Select a country"
																style={{ border: "1px solid #D9D9D9", borderRadius: "4px", color: "#8a8a8a", fontSize: "16px", padding: "4px 0" }}>
																{this.state?.countryList?.map((country) => {
																	return (
																		<Option key={country.short_name} value={JSON.stringify(country)}>
																			{country.country_name}
																		</Option>
																	);
																})}
																{/* <Option value='{"country_name":"uae","currency":"AED","isd_code":"971","timezone":"Asia/Dubai", "short_name":"AE"}'>
																	United Arab Emirates
																</Option>
																<Option value='{"country_name":"india","currency":"INR","isd_code":"91","timezone":"Asia/Kolkata", "short_name":"IN"}'>
																	India
																</Option> */}
															</Select>
														)}
													</Form.Item>
												</Row>
												<Row>
													<div>
														{/* <Logo /> */}
														<Text
															style={{
																//   position: "absolute",
																left: "calc(50% - 87.14px/2 - 0px)",
																//   top: "calc(50% - 31.33px/2 - 0.33px)",
																// fontFamily: "Gotham",
																fontStyle: "normal",
																fontWeight: "bold",
																fontSize: "14px",
																lineHeight: "22px",
																color: "#181818",
																marginTop: "32px",
															}}>
															Username
														</Text>
													</div>
													<Form.Item>
														{getFieldDecorator("username", {
															rules: [
																{
																	required: true,
																	message: "Please input your username!",
																},
															],
														})(<Input placeholder="Enter your username" style={{ border: "2px" }} />)}
													</Form.Item>
												</Row>
												<Row>
													<div>
														{/* <Logo /> */}
														<Text
															style={{
																//   position: "absolute",
																left: "calc(50% - 87.14px/2 - 0px)",
																//   top: "calc(50% - 31.33px/2 - 0.33px)",
																// fontFamily: "Gotham",
																fontStyle: "normal",
																fontWeight: "bold",
																fontSize: "14px",
																lineHeight: "22px",
																color: "#181818",
																marginTop: "32px",
															}}>
															Password
														</Text>
													</div>
													<Form.Item>
														{getFieldDecorator("password", {
															rules: [
																{
																	required: true,
																	message: "Please input your Password!",
																},
															],
														})(<Input type="password" placeholder="Enter your password" />)}
													</Form.Item>
													{/* <Row
														style={{
															display: "flex",
															justifyContent: "flex-end",
															// marginTop: "16xp",
														}}>
														<Link
															to="/forgot-password"
															style={{
																color: "#2D9140",
																fontStyle: "normal",
																fontWeight: "normal",
																fontSize: "16px",
																lineHeight: "24px",
															}}>
															Forget Password?
														</Link>
													</Row> */}
												</Row>

												<Button
													type="primary"
													htmlType="submit"
													//   onClick={() => {
													//     message.error(
													//       "Something went wrong! Please try again latter"
													//     );
													//   }}
													className="login-form-button"
													style={{
														width: "100%",
														background: "#fec708",
														marginTop: "32px",
													}}>
													Log in
												</Button>
											</Form>
										</Col>
									</Row>
								</>
							) : (
								<>
									<div style={{ padding: "24px" }}>
										<div
											style={{
												fontWeight: "bold",
												fontSize: "24px",
												lineHeight: "40px",
												color: "#181818",
											}}>
											Select Dashboard
										</div>
										<div
											style={{
												display: "inline-flex",
												gap: "26px",
												justifyContent: "space-between",
												alignItems: "center",
												width: "100%",
												marginTop: "32px",
											}}>
											<div
												style={{
													padding: "16px",
													display: "flex",
													alignItems: "center",
													flex: "1 1 100%",
													boxSizing: "border-box",
													boxShadow: "0px 5px 10px rgba(24, 24, 24, 0.05)",
													borderRadius: "10px",
													border: `1px solid ${this.state.selectedDashboard === "admin" ? "#1890FF" : "#F2F2F2"}`,
													cursor: "pointer",
												}}
												onClick={() => {
													this.setState({
														selectedDashboard: "admin",
													});
												}}>
												<div style={{ padding: "9px", borderRadius: "8px", background: "#E5F3FF", marginRight: "12px" }}>
													<Icon type="user" style={{ fontSize: "24px", color: "#1890FF" }} />
												</div>
												<div style={{ textAlign: "center", flexGrow: "1", fontWeight: "700", fontSize: "16px", lineHeight: "24px" }}>Admin</div>
											</div>
											<div
												style={{
													padding: "16px",
													display: "flex",
													alignItems: "center",
													flex: "1 1 100%",
													boxSizing: "border-box",
													boxShadow: "0px 5px 10px rgba(24, 24, 24, 0.05)",
													borderRadius: "10px",
													border: `1px solid ${this.state.selectedDashboard === "pos" ? "#1890FF" : "#F2F2F2"}`,
													cursor: "pointer",
												}}
												onClick={() => {
													this.setState({
														selectedDashboard: "pos",
													});
												}}>
												<div style={{ padding: "9px", borderRadius: "8px", background: "#F5E6FE" }}>
													<Icon type="user" style={{ fontSize: "24px", color: "#BE63F9" }} />
												</div>
												<div style={{ textAlign: "center", flexGrow: "1", fontWeight: "700", fontSize: "16px", lineHeight: "24px" }}>POS</div>
											</div>
										</div>
										<Button
											type="primary"
											disabled={!this.state.selectedDashboard}
											onClick={() => {
												localStorage.setItem("dashboard_type", this.state.selectedDashboard);
												window.location.reload();
											}}
											className="login-form-button"
											style={{
												width: "100%",
												background: "#fec708",
												marginTop: "32px",
												backgroundColor: this.state.selectedDashboard ? "#fec708" : "#E6E6E6",
											}}>
											Continue
										</Button>
									</div>
								</>
							)}
						</Col>
					</Row>
				</div>
			</div>
		);
	}
}

const SignIn = Form.create({ name: "normal_login" })(SignInForm);

export default SignIn;
